import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Contacts from '../Setup/Contacts/Contacts';
import Loader from '../Layout/Loader';
import useSettingsCompany from './useSettingsCompany';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import './settings.scss';

const ContactsSettings = () => {
  const { t } = useTranslation('translations');
  const {
    company,
    loading,
    isAdminMode,
    getBackUrl,
  } = useSettingsCompany();

  if (loading || !company) {
    return <Loader />;
  }

  return (
    <div className="settings-subpage">
      <SettingsBreadcrumb
        items={[{ label: t('mySuppliers.contacts') }]}
        company={company}
        isAdminMode={isAdminMode}
      />

      <div className="settings-subpage__header">
        <Link to={getBackUrl()} className="settings-subpage__back-btn">
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link>
        <h2 className="settings-subpage__title">
          <span className="settings-subpage__icon">
            <FontAwesomeIcon icon={faAddressBook} />
          </span>
          {t('mySuppliers.contacts')}
        </h2>
        {company && (
          <span className="settings-subpage__company-badge">
            {company.name}
          </span>
        )}
      </div>

      <Contacts company={isAdminMode ? company : undefined} />
    </div>
  );
};

export default ContactsSettings;
